import { render, staticRenderFns } from "./ShowClipartLayer.vue?vue&type=template&id=1f5538a4&scoped=true"
import script from "./ShowClipartLayer.vue?vue&type=script&lang=js"
export * from "./ShowClipartLayer.vue?vue&type=script&lang=js"
import style0 from "./ShowClipartLayer.vue?vue&type=style&index=0&id=1f5538a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5538a4",
  null
  
)

export default component.exports